import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import home from '../assets/home.png';
import u_logo from '../assets/u_logo.png';
import logom2 from '../assets/logom2.png';

function Header() {
    return (
        <header>
            <Link to="/" className="home-button"><img src={home} alt=""/></Link>
            <img src={logo} alt="Logo" className="logo"/>
            <div style={{width: '45px'}}></div>
            <img src={u_logo} alt="Logo" className="u_logo" style={{width: '48px'}}/>
            <img src={logom2} alt="Logo" className="logom2" style={{width: '81px'}}/>
        </header>
    );
}

export default Header;

